export const APP_NAME = 'Outright Jobs'

export const PAGE_SIZES = [10, 25, 50]
export const DEFAULT_PAGE_SIZE = 10

/** Debounce for a search that filters rows already in the browser. */
export const SEARCH_DEBOUNCE_MS = 300

/**
 * Debounce for a search the server answers. Long enough to type a whole name
 * without firing a request per word, since each one re-renders the table under
 * the field.
 */
export const SERVER_SEARCH_DEBOUNCE_MS = 1500

export const SORT_DIRECTIONS = { asc: 'asc', desc: 'desc' }

export const ACCESS_TOKEN_KEY = 'jwt_access_token'
export const UI_STORAGE_KEY = 'or-jobs.ui'
